import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { AmplitudeTypeOfLocations } from '@packlink/metrics';
import { AmplitudeEvents, AmplitudeProperties, FLOW_AMPLITUDE_PROPERTY } from '@constants/amplitude';
import { IOtherBenefitsForm } from './ShipmentPanelOtherBenefits';
import { useAmplitude } from '@common/hooks/useAmplitude';
import { IInsuranceProduct, InsuranceType } from '@packlink/packlink-sdk';
import { ShipmentInsuranceSelector } from '@common/components/ShipmentList/components/ShipmentInsuranceSelector/ShipmentInsuranceSelector';

export interface IOtherBenefitsInsuranceProps {
    insurance: IInsuranceProduct;
    onChangeValue: (value: boolean) => void;
    insurancePrice: string;
    contentValue?: number;
}

export const OtherBenefitsInsurance: React.FC<IOtherBenefitsInsuranceProps> = (
    props: IOtherBenefitsInsuranceProps,
): JSX.Element => {
    const { insurance, contentValue, insurancePrice, onChangeValue } = props;

    const { values, setFieldValue, validateForm } = useFormikContext<IOtherBenefitsForm>();
    const { sendAmplitudeEvent, sendAmplitudeSidebarClickEvent } = useAmplitude();

    useEffect((): void => {
        // Fix for enableReinitialize that resets form validations when async initialValues are set
        validateForm(values);
    }, [values, validateForm]);

    const sendPanelEvent = (data: Record<string, unknown>): void => {
        sendAmplitudeSidebarClickEvent(AmplitudeEvents.OTHER_BENEFITS_PANEL, data);
    };

    const onChangeInsurance = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>): void => {
        const insuranceSelected = value !== InsuranceType.NO_INSURANCE;
        setFieldValue('hasInsurance', insuranceSelected);
        onChangeValue(insuranceSelected);

        sendPanelEvent({
            [AmplitudeProperties.INSURANCE]: value,
            [AmplitudeProperties.CONTENT_VALUE]: !!contentValue,
        });
        sendAmplitudeEvent(AmplitudeEvents.CLICK_ON_INSURANCE, {
            [AmplitudeProperties.INSURANCE]: value,
            [AmplitudeProperties.FLOW]: FLOW_AMPLITUDE_PROPERTY.SIDE_PANEL,
            [AmplitudeProperties.LOCATION]: AmplitudeTypeOfLocations.ADDRESS_STEP,
        });
    };

    return <ShipmentInsuranceSelector insurance={insurance} onChange={onChangeInsurance} totalPrice={insurancePrice} />;
};
